import React from 'react';

import { currentConverter, MeasurementFieldType, TCurrentUnit } from 'models';

import type { MeasurementInputWrapperProps } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { MeasurementInputWrapper } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { UnitWithTooltip } from 'components/forms/fields/measurement/Unit';
import { useMultiUnitMeasurementController } from 'components/forms/fields/measurement/useMultiUnitMeasurementController';
import { useRenderVariableMultiInput } from 'components/forms/fields/measurement/useRenderVariableMultiInput';

type CurrentFieldProps = {
    name: string;
    placeholder?: string;
    fields?: MeasurementFieldType[];
    hideIcons?: boolean;
    defaultUnit?: TCurrentUnit;
} & MeasurementInputWrapperProps;

const CurrentField = ({
    name,
    placeholder,
    fields = ['nom', 'max'],
    hideIcons,
    defaultUnit,
    ...wrapperProps
}: CurrentFieldProps) => {
    const {
        unit,
        cycleUnit,
        fields: fieldsRecord,
    } = useMultiUnitMeasurementController({
        name,
        converter: currentConverter,
        defaultUnit,
        fields,
    });

    const Unit = <UnitWithTooltip onClick={cycleUnit}>{unit}</UnitWithTooltip>;

    const extraProps: any = {
        hideIcon: hideIcons,
        size: wrapperProps.size,
    };

    if (placeholder) {
        extraProps.placeholder = placeholder;
    }

    const Fields = useRenderVariableMultiInput({
        fields,
        fieldsRecord,
        Unit,
        extraProps,
    });

    return <MeasurementInputWrapper {...wrapperProps}>{Fields}</MeasurementInputWrapper>;
};

export { CurrentField };
